var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.spanClass},[_c('span',[_vm._v(_vm._s(_vm.params.dividend(_vm.params)))]),_vm._v(" / "+_vm._s(_vm.params.divisor())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }